import noticeboardData from './noticeboard.json';
import noticesData from './notices.json';
import calendarData from './calendar.json';
import circlesData from './circles.json';
import signupData from './signup.json';
import loginData from './login.json';
import userManagementData from './userManagement.json';
import accountData from './account.json';
import privacyData from './privacy.json';

export interface KnowledgeItem {
  id: string;
  title: string;
  description: string;
  category: string;
  icon: string;
  tags: string[];
  content: any;
}

export interface ProductIndex {
  products: Array<{
    id: string;
    file: string;
    category: string;
    priority: number;
  }>;
  categories: Array<{
    name: string;
    description: string;
    icon: string;
  }>;
}

export const knowledgeItems: KnowledgeItem[] = [
  noticeboardData,
  noticesData,
  calendarData,
  circlesData,
  signupData,
  loginData,
  userManagementData,
  accountData,
  privacyData,
];

export const productIndex: ProductIndex = {
  products: [
    {
      "id": "noticeboard",
      "file": "noticeboard.json",
      "category": "Core Features",
      "priority": 1
    },
    {
      "id": "notices",
      "file": "notices.json",
      "category": "Core Features",
      "priority": 2
    },
    {
      "id": "calendar",
      "file": "calendar.json",
      "category": "Core Features",
      "priority": 3
    },
    {
      "id": "circles",
      "file": "circles.json",
      "category": "Administration",
      "priority": 4
    },
    {
      "id": "signup",
      "file": "signup.json",
      "category": "Getting Started",
      "priority": 5
    },
    {
      "id": "login",
      "file": "login.json",
      "category": "Getting Started",
      "priority": 6
    },
    {
      "id": "userManagement",
      "file": "userManagement.json",
      "category": "Administration",
      "priority": 7
    },
    {
      "id": "account",
      "file": "account.json",
      "category": "Account",
      "priority": 8
    },
    {
      "id": "privacy",
      "file": "privacy.json",
      "category": "Support",
      "priority": 9
    }
  ],
  categories: [
    {
      name: "Getting Started",
      description: "Essential information for new users",
      icon: "Home"
    },
    {
      name: "Core Features",
      description: "Main platform functionality",
      icon: "EventNote"
    },
    {
      name: "Administration",
      description: "Management and organizational tools",
      icon: "Groups"
    },
    {
      name: "Analytics",
      description: "Data insights and reporting",
      icon: "Analytics"
    },
    {
      name: "Account",
      description: "User profile and settings",
      icon: "Person"
    },
    {
      name: "Best Practices",
      description: "Tips for effective platform usage",
      icon: "CheckCircle"
    },
    {
      name: "Support",
      description: "Help and troubleshooting",
      icon: "Help"
    }
  ]
};
